import React, { createContext, useState, ReactNode, useContext } from "react";
import { Dialog, Theme, useMediaQuery } from "@mui/material";

interface DialogContext {
  openWithContent: any;
  closeModal: () => void;
}

export const DialogContext = createContext<DialogContext>({} as any);

type DialogProviderProps = {
  children: ReactNode;
};

export const DialogProvider = ({ children }: DialogProviderProps) => {
  const [content, setContent] = useState(null);
  const [open, setOpen] = useState(false);
  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const openWithContent = (content: any) => {
    setContent(content);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setContent(null);
  };

  return (
    <DialogContext.Provider value={{ openWithContent, closeModal }}>
      {content && (
        <Dialog
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                minWidth: "fit-content",
                borderRadius: mobile ? 2 : 1,
                overflow: "auto",
              },
            },
          }}
        >
          {content}
        </Dialog>
      )}
      {children}
    </DialogContext.Provider>
  );
};

export const useDialogContext = () => useContext<DialogContext>(DialogContext);
